import { getAxiosNotif, getAxiosTotall } from "./ApiInstance";

/////////////////  Get Method  ////////////////////
export const getMessageListApi = (id, callback) => {
  getAxiosTotall()
    .get(`support/chat/${id}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getUsersListApi = (callback) => {
  getAxiosTotall()
    .get("users/customer/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getSupplierListApi = (callback) => {
  getAxiosTotall()
    .get("users/supplier/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getProductBaseSupplierId = (id, callback) => {
  getAxiosTotall()
    .get(`products/productlist/supplier/${id}`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getDeliveryListApi = (callback) => {
  getAxiosTotall()
    .get("users/delivery/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getAdminListApi = (callback) => {
  getAxiosTotall()
    .get("users/admin/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getUserAddressApi = (id, callback) => {
  getAxiosTotall()
    .get(`users/${id}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getOrdersDeliveredApi = (callback) => {
  getAxiosTotall()
    .get("orders/delivered/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getOrdersListApi = (orderId, supId, callback) => {
  getAxiosTotall()
    .get(`orders/detail/${orderId}/${supId}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const GetWithdrawList = (callback) => {
  getAxiosTotall()
    .get(`accounting/withdraw/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const GetPayedWithdrawListAPI = (callback) => {
  getAxiosTotall()
    .get(`accounting/withdrawn/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getActiveOrderApi = (callback) => {
  getAxiosTotall()
    .get("orders/active/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getAllOrderApi = (statusOrder, callback) => {
  const statusParam = statusOrder ? statusOrder : "";
  const url = `orders/all/?status=${statusParam}`;

  getAxiosTotall()
    .get(url)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getAllOrderByLimitApi = (day, callback) => {
  const datparam = day ? day : "";
  const url = `orders/all/?limit=${datparam}`;

  getAxiosTotall()
    .get(url)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getSupplierInfoApi = (id, callback) => {
  getAxiosTotall()
    .get(`users/info/supplier/${id}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getDeliveryInfoApi = (id, callback) => {
  getAxiosTotall()
    .get(`users/info/delivery/${id}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getAdminInfoAPI = (id, callback) => {
  getAxiosTotall()
    .get(`users/info/admin/${id}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getVehicleListApi = (callback) => {
  getAxiosTotall()
    .get(`users/vehicle_model/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getColorListAPI = (callback) => {
  getAxiosTotall()
    .get(`users/vehicle_color/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const EditUserAPI = (info, callback) => {
  getAxiosTotall()
    .post(`users/update/`, info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
// export const getAdminInfoAPI=(id,callback)=>{
//     getAxiosTotall().get(`users/info/admin/${id}/`).then(response=>{
//         callback(true,response.data)
//     }).catch(error=>{
//         callback(false,error)
//     })
// }
export const getAcceptedSupplierApi = (callback) => {
  getAxiosTotall()
    .get("orders/preparing/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getOrderPreparedApi = (callback) => {
  getAxiosTotall()
    .get("orders/ready/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getDeliveryApi = (cityId, callback) => {
  getAxiosTotall()
    .get(`users/delivery/${cityId}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getAcceptedDeliveryApi = (callback) => {
  getAxiosTotall()
    .get("orders/delivery/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getAllRestaurantCommentApi = (callback) => {
  getAxiosTotall()
    .get("comments/food/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getAllSupperMarketCommentApi = (callback) => {
  getAxiosTotall()
    .get("comments/supermarket/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getFailedPayListApi = (callback) => {
  getAxiosTotall()
    .get("accounting/unmatched_transaction/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
// export const getSupplierSupportApi = (callback) => {
//   getAxiosTotall()
//     .get("support/supplier/")
//     .then((response) => {
//       callback(true, response.data);
//     })
//     .catch((error) => {
//       callback(false, error);
//     });
// };
export const getUserSupportApi = (callback) => {
  getAxiosTotall()
    .get("support/list/user/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getDeliverySupportApi = (callback) => {
  getAxiosTotall()
    .get("support/list/delivery/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getSupplierSupportApi = (callback) => {
  getAxiosTotall()
    .get("support/list/supplier/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getFoodCategoryApi = (supId, callback) => {
  getAxiosTotall()
    .get(`products/category/${supId}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getSupermarketCategoryApi = (callback) => {
  getAxiosTotall()
    .get("products/category/supermarket/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getRestaurantProductListApi = (callback) => {
  getAxiosTotall()
    .get("products/productlist/food/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getSupermarketProductListApi = (callback) => {
  getAxiosTotall()
    .get("products/productlist/supermarket/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getDetailProductApi = (productId, callback) => {
  getAxiosTotall()
    .get(`products/detail/${productId}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getDetailProductSupperyApi = (productId, supID, callback) => {
  getAxiosTotall()
    .get(`products/detail/${productId}/${supID}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getBrandsApi = (callback) => {
  getAxiosTotall()
    .get("products/brand/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getCategorySuperyApi = (callback) => {
  getAxiosTotall()
    .get("products/category/supermarket/")
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getSupplierProdctsAPI = (id, callback) => {
  getAxiosTotall()
    .get(`products/productlist/supplier/${id}`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getSupplierOffsAPI = (callback) => {
  getAxiosTotall()
    .get(`products/supplierlist/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getDeliveryCostDataAPI = (callback) => {
  getAxiosTotall()
    .get(`users/deliverypriceratio/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getBrandDataAPI = (callback) => {
  getAxiosTotall()
    .get(`brand/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getInfoAPI = (callback) => {
  getAxiosTotall()
    .get(`info/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error);
    });
};
export const getResturantCategoryAPI = (callback) => {
  getAxiosTotall()
    .get(`products/category/food/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const getDeliverLocaApi = (orderId, callback) => {
  getAxiosTotall()
    .get(`orders/location/?id=${orderId}`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const getWalletInfoApi = (userId, callback) => {
  getAxiosTotall()
    .get(`users/accounting/supplier/${userId}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const getWalletInfoDeliverApi = (userId, callback) => {
  getAxiosTotall()
    .get(`users/accounting/deliver/${userId}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const getUserInfoApi = (id, callback) => {
  getAxiosTotall()
    .get(`users/info/customer/${id}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const getWalletInfoCustomerApi = (userId, callback) => {
  getAxiosTotall()
    .get(`users/accounting/user/${userId}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const getCheckOutApi = (trackId, callback) => {
  getAxiosTotall()
    .get(`users/checkcashout/${trackId}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const getTravelDetailAPI = (id, callback) => {
  getAxiosTotall()
    .get(`taxi/travel/${id}/`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const getAcountingApi = (callback) => {
  getAxiosTotall()
    .get(`accounting/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const getTravelsListApi = (callback) => {
  getAxiosTotall()
    .get(`taxi/travels/`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const getPublicDiscountListApi = (callback) => {
  getAxiosTotall()
    .get(`users/public_discount/`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const getPrivateDiscountListApi = (callback) => {
  getAxiosTotall()
    .get(`users/private_discount/`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const getDeliveryReqListApi = (callback) => {
  getAxiosTotall()
    .get(`delivery/requests/`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const getFactorListApi = (callback) => {
  getAxiosTotall()
    .get(`facture/`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const getFactorTransactionDetailApi = (id, callback) => {
  getAxiosTotall()
    .get(`facture/transaction/${id}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const getBarestHelpListApi = (callback) => {
  getAxiosTotall()
    .get(`/debt/list`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const getBarestHelpUserInstalmentApi = (id, callback) => {
  getAxiosTotall()
    .get(`/debt/installment/${id}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const getDeliveryReqDetailApi = (requId, callback) => {
  getAxiosTotall()
    .get(`delivery/request/${requId}/`)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
/////////////////  Post Method  ////////////////////

export const LoginPostApi = (info, callback) => {
  getAxiosTotall()
    .post("login/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const setScorePostApi = (info, callback) => {
  getAxiosTotall()
    .post("users/score/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const editCustomerInfoPostApi = (info, callback) => {
  getAxiosTotall()
    .post("users/update/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const editAddressPostApi = (info, callback) => {
  getAxiosTotall()
    .post("users/address/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const WithdrawRequesAPI = (info, callback) => {
  getAxiosTotall()
    .post("accounting/withdraw/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const cancelOrderPostApi = (info, callback) => {
  getAxiosTotall()
    .post("orders/status/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const deactivateUserPostApi = (info, callback) => {
  getAxiosTotall()
    .post("users/status/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const setDeliveryPostApi = (info, callback) => {
  getAxiosTotall()
    .post("orders/delivery/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const commentConditionPostApi = (info, callback) => {
  getAxiosTotall()
    .post("comments/status/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const AddRestaurantProductsPostApi = (info, callback) => {
  getAxiosTotall()
    .post("products/add/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const AssignToSupplierPostApi = (info, callback) => {
  getAxiosTotall()
    .post("products/assign/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const AddUserPostApi = (info, callback) => {
  getAxiosTotall()
    .post("users/add/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const EditSuperyProductPostApi = (info, callback) => {
  getAxiosTotall()
    .post("products/update/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const removeProductPostApi = (info, callback) => {
  getAxiosTotall()
    .post("products/remove/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const AddDiscountAPI = (info, callback) => {
  getAxiosTotall()
    .post("products/off/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const AddmarketCategoryAPI = (info, callback) => {
  getAxiosTotall()
    .post("products/category/add/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const EditmarketCategoryAPI = (info, callback) => {
  getAxiosTotall()
    .post("products/category/update/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const RemovemarketCategoryAPI = (info, callback) => {
  getAxiosTotall()
    .post("products/category/remove/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};

export const ChangePRoductsCategoryAPI = (info, callback) => {
  getAxiosTotall()
    .post("products/update/category/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const EditSupplierProductAPI = (info, callback) => {
  getAxiosTotall()
    .post("products/update/limit/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const UpdateDeliverCostAPI = (info, callback) => {
  getAxiosTotall()
    .post("users/deliverypriceratio/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const AddBrandAPI = (info, callback) => {
  getAxiosTotall()
    .post("brand/add/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const removeImageApi = (info, callback) => {
  getAxiosTotall()
    .post("products/removeimage/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const removeBrandApi = (info, callback) => {
  getAxiosTotall()
    .post("brand/remove/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const UpdateBrandAPI = (info, callback) => {
  getAxiosTotall()
    .post("brand/update/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const LogoutAPI = (info, callback) => {
  getAxiosTotall()
    .post("logout/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const editShabaPostAPI = (info, callback) => {
  getAxiosTotall()
    .post("users/updateiban/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const AddResturantCategoryAPI = (info, callback) => {
  getAxiosTotall()
    .post("products/foodcategory/add/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const RemoveResturantCategoryAPI = (info, callback) => {
  getAxiosTotall()
    .post("products/foodcategory/remove/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const updateResturantCategoryAPI = (info, callback) => {
  getAxiosTotall()
    .post("products/foodcategory/update/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const sendNotifInfo = (info, callback) => {
  getAxiosNotif()
    .post("fcm/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const sendToPanelDeliverApi = (info, callback) => {
  getAxiosTotall()
    .post("users/login", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const sendDiscountCodeApi = (info, callback) => {
  getAxiosTotall()
    .post("users/discount/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const changePasswordPostApi = (info, callback) => {
  getAxiosTotall()
    .post("info/updatepassword/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const setAmountPostApi = (info, callback) => {
  getAxiosTotall()
    .post("users/wallet/", info)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback(error.data);
    });
};
export const AddVehicleApi = (info, callback) => {
  getAxiosTotall()
    .post("users/vehicle_model/", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const ColorAPI = (info, callback) => {
  getAxiosTotall()
    .post("users/vehicle_color/", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const createPublicDiscountApi = (info, callback) => {
  getAxiosTotall()
    .post("users/public_discount/", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const createPrivateDiscountApi = (info, callback) => {
  getAxiosTotall()
    .post("users/private_discount/", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};

export const supportStatusApi = (info, callback) => {
  getAxiosTotall()
    .post("support/status/", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const postSupportMessageApi = (info, callback) => {
  getAxiosTotall()
    .post("support/message/", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const searchUserByPhoneAPI = (info, callback) => {
  getAxiosTotall()
    .post("users/search_user/", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
}
export const createFActorApi = (info, callback) => {
  getAxiosTotall()
    .post("facture/create", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};

export const cancelFactureApi = (info, callback) => {
  getAxiosTotall()
    .post("facture/status", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const recalculatePaymentApi = (info, callback) => {
  getAxiosTotall()
    .post("accounting/unmatched_transaction", info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
export const updateSupplierOpenApi = (info, callback) => {
  getAxiosTotall()
    .post(`/users/update_supplier_open/`, info)
    .then((response) => {
      callback(true, response.data);
    })
    .catch((error) => {
      callback(false, error.data);
    });
};
